import { useCallback, useState } from "react";

// useDisclosure (CN-disclosure) — the collapse/expand state machine shared by
// every foldable box: the Home weekly-targets card, the AP-3b in-workout strip,
// and (migrating later) FeedbackRow / ProgramSpine / ComposerEntryRow, which
// each hand-rolled this identical `useState` + toggle + `accessibilityState`
// pairing. The chrome differs per surface (badge row vs grid toggle vs plain
// chevron), so this stays a hook, not a full <Disclosure> component — only the
// state + a11y prop are byte-identical, and that's all it shares.
export function useDisclosure(initial = false): {
  expanded: boolean;
  toggle: () => void;
  setExpanded: (v: boolean) => void;
  // Spread onto the toggling Pressable so the screen reader announces the
  // state. `aria-expanded` too: RNW drops `accessibilityState`, and RN maps
  // the aria prop natively (Chip.tsx, IconButton.tsx, same choice).
  a11yProps: { accessibilityState: { expanded: boolean }; "aria-expanded": boolean };
} {
  const [expanded, setExpanded] = useState(initial);
  const toggle = useCallback(() => setExpanded((v) => !v), []);
  return {
    expanded,
    toggle,
    setExpanded,
    a11yProps: { accessibilityState: { expanded }, "aria-expanded": expanded },
  };
}
